export default __webpack_public_path__ + "static/media/cern-semibold-italic.743d2784.woff";